import React from "react";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Home() {
	let navigate = useNavigate();
	return (
		<div className="page-content">
			<Typography variant="h4" style={{ marginBottom: 30 }}>
				Model proof of concept developed for Social Care Wales
			</Typography>
			<Typography variant="h5" style={{ fontWeight: "bold" }}>
				Developed by Alma Economics
			</Typography>
			<Typography variant="h6" style={{ marginBottom: 30 }}>
				April 2023
			</Typography>
			<Typography variant="h6" style={{ marginBottom: 30 }}>
				We developed a proof-of-concept working model to provide
				high-level projections of children looked after (CLA) in Wales,
				including assessing the impact of changes to children's social
				care policies as well as incidence of risk factors on such
				projections. This proof-of-concept working model is for
				demonstration purposes only and it has not been comprehensively
				tested for errors or omissions. Thus, it shouldn't be used for
				drawing conclusions and designing policy interventions.
			</Typography>
			<Typography
				variant="subtitle1"
				style={{
					marginBottom: 15,
					fontWeight: "bold",
				}}
			>
				This online model includes the following tabs:
			</Typography>
			<Typography
				variant="body1"
				style={{
					borderBottom: "1px solid #bfbfbf",
					marginBottom: 30,
					cursor: "pointer",
				}}
				onClick={() => navigate("/scenario-analysis")}
			>
				<span
					style={{
						color: " #007b67",
						fontWeight: "bold",
						width: 170,
						display: "block",
					}}
				>
					Scenario Analysis
				</span>
				includes a prototype interactive dashboard that allows to
				visualise outputs.
			</Typography>
			<Typography
				variant="body1"
				style={{
					borderBottom: "1px solid #bfbfbf",
					marginBottom: 30,
					cursor: "pointer",
				}}
				onClick={() => navigate("/risk-factor-analysis")}
			>
				<span
					style={{
						color: " #007b67",
						fontWeight: "bold",
						width: 170,
						display: "block",
					}}
				>
					Risk Factor Analysis
				</span>
				presents projections on the number of CLA in each Local
				Authority based on a regression model that accounts for the
				incidence of risk factors (e.g. deprivation) in each Local
				Authority.
			</Typography>
			<Typography
				variant="body1"
				style={{
					borderBottom: "1px solid #bfbfbf",
					marginBottom: 30,
					cursor: "pointer",
				}}
				onClick={() => navigate("/benchmarking")}
			>
				<span
					style={{
						color: " #007b67",
						fontWeight: "bold",
						width: 170,
						display: "block",
					}}
				>
					Benchmarking
				</span>
				presents statistics on the observed number of children looked
				after across Local Authorities compared with the predicted
				values from the regression model (i.e. accounting for the
				incidence of risk factors).
			</Typography>
			<Typography
				variant="body1"
				style={{
					borderBottom: "1px solid #bfbfbf",
					marginBottom: 30,
					cursor: "pointer",
				}}
				onClick={() => navigate("/time-series-forecasting")}
			>
				<span
					style={{
						color: " #007b67",
						fontWeight: "bold",
						width: 170,
						display: "block",
					}}
				>
					Time Series Forecasting
				</span>
				includes predictions on key indicators (e.g. proportion of CLA)
				using historical data.
			</Typography>
			<Typography
				variant="subtitle1"
				style={{
					marginBottom: 15,
					fontWeight: "bold",
				}}
			>
				To access the report, please click on the links below:
			</Typography>
			<Typography
				variant="body1"
				style={{
					marginBottom: 10,
					cursor: "pointer",
				}}
				onClick={() => window.open("/report/english", "_blank")}
			>
				<span
					style={{
						color: " #007b67",
						fontWeight: "bold",
						width: 170,
						display: "block",
					}}
				>
					- English version
				</span>
			</Typography>
			<Typography
				variant="body1"
				style={{
					marginBottom: 10,
					cursor: "pointer",
				}}
				onClick={() => window.open("/report/welsh", "_blank")}
			>
				<span
					style={{
						color: " #007b67",
						fontWeight: "bold",
						width: 170,
						display: "block",
					}}
				>
					- Welsh version
				</span>
			</Typography>
		</div>
	);
}

export default Home;
